export default {
    admin: 'Admin',
    manager: 'Manager',
    teamIncharge: 'Team Incharge',
    teamMember: 'Team Member'
};
